export default "__VITE_ASSET__Ys8ymT5W__"